module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-input-number",
    class: _vm.classes,
    on: {
      "mouseenter": function($event) {
        _vm.inputHovering = true
      },
      "mouseleave": function($event) {
        _vm.inputHovering = false
      }
    }
  }, [_c('el-input-number', _vm._b({
    ref: "input",
    attrs: {
      "value": _vm.currentValue,
      "max": _vm.max,
      "min": _vm.min,
      "controls": _vm.controls,
      "show-close": !!_vm.showClose,
      "disabled": _vm.disabled,
      "precision": _vm.precision,
      "placeholder": _vm.computedInputPlaceholder
    },
    on: {
      "input": _vm.inputHandler,
      "change": _vm.changeHandler,
      "blur": _vm.blurHandler,
      "focus": _vm.handleFocus,
      "display-value-change": _vm.displayValueChangeHandler
    }
  }, 'el-input-number', _vm.$attrs, false), [(!_vm.controls) ? _vm._t("prefix", function() {
    return [_vm._t("prefix")]
  }, {
    "slot": "prefix"
  }) : _vm._e(), _vm._v(" "), (_vm._computedRecordIcon) ? _c('rt-icon', {
    staticClass: "rt-xpc-input-suffix",
    attrs: {
      "slot": "suffix",
      "color": _vm.SCSS_VARIABLES.COLOR_INFO,
      "name": "rt-base-record-lined"
    },
    on: {
      "click": _vm.inputFocus
    },
    slot: "suffix"
  }) : _vm._e(), _vm._v(" "), (_vm.showClose) ? _c('rt-icon', {
    staticClass: "rt-xpc-input-clearicon",
    style: (_vm.computedClearIconStyle),
    attrs: {
      "slot": "suffix",
      "name": _vm.computedIconName,
      "color": _vm.SCSS_VARIABLES.COLOR_SECONDARY
    },
    on: {
      "click": _vm.clear
    },
    slot: "suffix"
  }) : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4086f9f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/form/rtInputNumber.vue
// module id = 2126
// module chunks = 137